import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { ScheduleFreshnessDto } from '../lib/types';

/**
 * How current the schedule data is.
 *
 * Polled rather than fetched once: a tech leaves the app open in the truck for hours, and the
 * point of the banner is to catch exactly that case. Fifteen minutes is far below the 24-hour
 * staleness threshold, so the banner appears well within the hour it becomes true, and the
 * query itself reads one indexed row.
 */
export function useScheduleFreshness() {
  return useQuery({
    queryKey: ['schedule-freshness'],
    queryFn: () => apiClient.get<ScheduleFreshnessDto>('/api/schedule/freshness'),
    refetchInterval: 15 * 60_000,
    refetchOnWindowFocus: true,
    // A failed freshness check must never surface as a page error — it is metadata about the
    // page, not the page's content.
    retry: 1,
  });
}
